import React from 'react';
import classnames from 'classnames';
import HiddenIcon from '@wix/da-ds/pkg/Icons/Hidden';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import Flex from '@wix/da-ds/pkg/Flex';
import s from './Hidden.scss';
var HiddenDumbView = function (_a) {
    var className = _a.className, width = _a.width, height = _a.height;
    var canShowHugeIcon = Math.min(width !== null && width !== void 0 ? width : Infinity, height !== null && height !== void 0 ? height : Infinity) > 48;
    return (React.createElement(Flex, { className: classnames(s['root'], className), justifyContent: "center", alignItems: "center", style: {
            width: width || height,
            height: height || width,
        } },
        React.createElement(HiddenIcon, { size: canShowHugeIcon ? IconSize.HUGE : IconSize.SMALL })));
};
HiddenDumbView.displayName = 'HiddenDumbView';
export default HiddenDumbView;
//# sourceMappingURL=Hidden.js.map